import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M0,0h24v24h-24Z" }),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				fill: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M12,21v0c-4.971,0 -9,-4.029 -9,-9v0c0,-4.971 4.029,-9 9,-9v0c4.971,0 9,4.029 9,9v0c0,4.971 -4.029,9 -9,9Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#fff",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M16,10l-5,5l-3,-3"
			})
		]
	})
});
export default SvgCheckCircle;
